// extracted by mini-css-extract-plugin
module.exports = {"FooterMenu":"styles_FooterMenu__EnxZu","height":"styles_height__uMSP6"};